import React, { useCallback, useState } from 'react';
import { useLessonContext } from '../LessonContext';
import { courseRunsService } from '../../../services/courseRunsService';

export function EmptyStageNotice({ stageId, contentType }: { stageId: string; contentType: string }) {
  const { lessonRun, refreshRun } = useLessonContext();
  const isCompleted = (lessonRun?.stages || []).some(
    (s) => s.stage_id === stageId && s.status === 'succeeded'
  );
  const [marking, setMarking] = useState(false);

  const handleMarkComplete = useCallback(async () => {
    if (!lessonRun?.run_id) return;
    setMarking(true);
    try {
      await courseRunsService.approveLessonStage(lessonRun.run_id, stageId);
      await refreshRun();
    } finally {
      setMarking(false);
    }
  }, [lessonRun?.run_id, stageId, refreshRun]);

  if (isCompleted) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-md px-4 py-3 text-sm text-gray-600 flex items-center gap-2">
        <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        No {contentType} in this lesson. Stage completed.
      </div>
    );
  }

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-md px-4 py-4 space-y-3">
      <div className="text-sm text-gray-600">
        The lesson content does not include any {contentType} specs. This is fine — not every lesson needs {contentType}.
      </div>
      <button
        type="button"
        className="px-3 py-1.5 text-sm rounded-md text-white hover:opacity-90 disabled:opacity-50"
        style={{ backgroundColor: '#1a2332' }}
        disabled={marking}
        onClick={handleMarkComplete}
      >
        {marking ? 'Marking...' : 'Skip — Mark Complete'}
      </button>
    </div>
  );
}
